import { render } from "./CustomerExport.vue?vue&type=template&id=05e12979"
import script from "./CustomerExport.vue?vue&type=script&lang=js"
export * from "./CustomerExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__